import classNames from "classnames";
import Styles from "./Payment.module.scss";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import logo from "../../assets/images/logo/kzg_logo-01.png";
import { Verify, getPaymentCompany } from "../BGService/kzgAPI";
import PaymentModal from "../../Component/Modals/PaymentModals";
import ReCAPTCHA from "react-google-recaptcha";
import lineQRcode from "../../assets/payment/Line_QRcode.png";

const Payment = () => {
  const [isZeroModalOpen, setIsZeroModalOpen] = React.useState(false);
  const [isNotFoundModalOpen, setIsNotFoundModalOpen] = React.useState(false);

  const containerRef = React.useRef();

  const formRef = React.useRef();
  const navigate = useNavigate();

  const [captchaToken, setCaptchaToken] = React.useState("");
  const recaptchaRef = React.useRef();
  const [verify, setVerify] = React.useState(false);

  const siteKey = "6LcbaEwrAAAAAHeihDI8E3d6OCCaI2japy7gObI9";

  /**
   * Async Function
   */

  async function fetchPaymentCompany(caseId) {
    const response = await getPaymentCompany({ caseId: caseId });
    if (response.status !== 200) {
      setIsNotFoundModalOpen(true);
    } else {
      if (response.count === 0) {
        setIsNotFoundModalOpen(true);
      } else {
        localStorage.setItem("caseId", caseId);
        navigate(`/payment_temp/summary`);
      }
    }
  }

  async function fetchVerify(token, formData) {
    const response = await Verify({
      token: token,
    });
    if (response.status !== 200) {
    } else {
      setVerify(response.data);
      console.log("async function", response.data);
      if (response.data === false) {
        alert("!!請遵守網站使用條款!!");
      } else {
        if (formData.get("caseId").trim() === "") {
          alert("請輸入個案身份證字號");
        } else {
          // localStorage.setItem("company", formData.get("company"));
          localStorage.setItem(
            "caseId",
            formData.get("caseId").trim().toUpperCase()
          );
          fetchPaymentCompany(
            // formData.get("company"),
            formData.get("caseId").trim().toUpperCase()
          );
        }
      }
    }
  }

  /**
   * useEffect
   */

  // useEffect(() => {
  //   navigate("/systemRepair")
  // }, []);

  /** Handling */
  const handleSubmit = (e) => {
    e.preventDefault(); //防止重新整理頁面
    const formData = new FormData(formRef.current);
    if (!captchaToken) {
      alert("請先完成驗證");
      return;
    }
    fetchVerify(captchaToken, formData);
  };

  const handleBlur = () => {
    // 當鍵盤收起後，自動滾到 container 最上方
    containerRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className={classNames(Styles.payment)}>
      <div className={classNames("container")}>
        <div>
          <img
            className={classNames(Styles.payment__logo)}
            src={logo}
            alt="logo"
          />
          <h3 className={classNames(Styles.payment__title)}>
            {" "}
            個案綁定逾時頁面
          </h3>

          <p className={classNames(Styles.payment__param)}>
            綁定流程：請關閉此頁面，並由LINE官方帳號【肯兆固繳費專區】中，點選【點我綁定】進行綁定。
          </p>
          <p className={classNames(Styles.payment__param)}>↓↓↓加入好友↓↓↓</p>
          <img src={lineQRcode} alt="繳費專區LINE QRcode" />
          {/* <form ref={formRef} onSubmit={handleSubmit}>
            <div ref={containerRef} className="row mb-3">
              <div
                className={classNames(
                  "col-sm-12",
                  "col-md-6",
                  "col-lg-6",
                  Styles.payment__table__title
                )}
              >
                個案身份證字號(<span>必填</span>)
              </div>
              <div
                className={classNames(
                  "col-sm-12",
                  "col-md-6",
                  "col-lg-6",
                  Styles.payment__table__input
                )}
              >
                <input onBlur={handleBlur} name="caseId" type="text" />
              </div>
            </div>
            <div className={classNames("row", "mb-3")}>
              <div
                className={classNames("col-sm-12", "col-md-12", "col-lg-12")}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={siteKey}
                  onChange={(token) => {
                    setCaptchaToken(token);
                  }}
                />
              </div>
            </div>

            <button className={classNames(Styles.payment__btn)} type="submit">
              送出
            </button>
          </form> */}
        </div>
      </div>
      <div>
        <PaymentModal
          isOpen={isZeroModalOpen}
          onClose={() => setIsZeroModalOpen(false)}
          CloseBtn={true}
        >
          {`該期部分負擔為0元，無須繳費!!`}
        </PaymentModal>
      </div>
      <div>
        <PaymentModal
          isOpen={isNotFoundModalOpen}
          onClose={() => setIsNotFoundModalOpen(false)}
          CloseBtn={true}
        >
          {`未找到符合的繳款資訊`}
          <br />
          {`請輸入正確資料`}
        </PaymentModal>
      </div>
    </div>
  );
};
export default Payment;
